module.exports = __webpack_public_path__ + "static/img/civil_icon9.0da8ee5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/civil_icon9.png
// module id = J9Zi
// module chunks = 1